import type { ApiData } from '../types';

export const MOCK_DATA: ApiData = {
  categories: [
    {
      id: 'cat-valentines', name: "Valentine's Day Specials!",
      services: [
        {
          id: 'svc-v1', name: 'Love is in the Air Couples Massage', price: 230, duration: 60,
          enhancementGroupIds: ['eg-main', 'eg-cupping'],
          description: 'Celebrate your love with a side-by-side massage in our couples suite. Includes warm aromatic towels and a rose petal setup. A truly romantic and indulgent experience for you and your partner.'
        },
        {
          id: 'svc-v2', name: 'Love Oil Massage (Limited Time)', price: 135, duration: 60,
          enhancementGroupIds: ['eg-main'],
          description: "Indulge in our exclusive Valentine's blend of sandalwood, ylang ylang, rose, and vanilla. A deeply sensory massage experience, available for a limited time only."
        }
      ]
    },
    {
      id: 'cat-new', name: '*New* For the New Year',
      services: [
        {
          id: 'svc-n1', name: 'New Year Reset Facial', price: 110, duration: 60,
          enhancementGroupIds: ['eg-main'],
          description: 'Start the year fresh with our comprehensive reset facial. Deeply cleanses, exfoliates, and nourishes your skin, leaving you glowing and ready for the year ahead.'
        }
      ]
    },
    {
      id: 'cat-retail', name: 'Retail Sales Appointments (Free)',
      services: [
        {
          id: 'svc-r1', name: 'Personalized Retail Consultation', price: 0, duration: 30,
          enhancementGroupIds: [],
          description: 'Meet with our knowledgeable staff to find the perfect products for your skincare, wellness, or self-care routine. Completely free, no purchase required.'
        }
      ]
    },
    {
      id: 'cat-massage', name: 'Massage',
      services: [
        {
          id: 'svc-m1', name: '30 Minute Massage', price: 70, duration: 30,
          enhancementGroupIds: ['eg-main', 'eg-cupping'],
          description: 'A focused 30-minute session targeting your areas of tension. Perfect for a quick refresh.'
        },
        {
          id: 'svc-m2', name: '60 Minute Amber and Sage Massage', price: 115, duration: 60,
          enhancementGroupIds: ['eg-main', 'eg-cupping', 'eg-reiki'],
          description: 'Relax and unwind with our signature 60-minute Custom Massage, thoughtfully tailored to your individual needs. Our skilled therapist will use a blend of techniques to focus on areas of discomfort or tightness. Every session includes warm, aromatic towels. Walk away feeling refreshed, rejuvenated, and completely at ease.'
        },
        {
          id: 'svc-m3', name: '60 Minute Amber and Sage Massage for Two (Separate Rooms)', price: 230, duration: 60,
          enhancementGroupIds: ['eg-main', 'eg-cupping'],
          description: 'Share the gift of relaxation. Both guests receive a full 60-minute massage simultaneously in separate, private treatment rooms.'
        },
        {
          id: 'svc-m4', name: '60 Minute Deep Tissue Massage', price: 135, duration: 60,
          enhancementGroupIds: ['eg-main', 'eg-cupping'],
          description: 'Designed for chronic muscle tension and deep-seated knots, using firm pressure and slow, deliberate strokes targeting inner layers of muscle tissue.'
        },
        {
          id: 'svc-m5', name: '60 Minute Medicinal Plant-Infused Lotion Massage', price: 150, duration: 60,
          enhancementGroupIds: ['eg-main', 'eg-cupping'],
          description: 'Enhanced with hemp-derived plant-infused products from Cause+Medic to reduce inflammation, relieve chronic pain, calm the nervous system, and promote deep relaxation.'
        },
        {
          id: 'svc-m6', name: '60 Minute Hot Stone Massage', price: 148, duration: 60,
          enhancementGroupIds: ['eg-main'],
          description: 'Warm basalt stones are placed on key points and used to massage muscles. The penetrating heat melts away tension and creates a profoundly relaxing experience.'
        },
        {
          id: 'svc-m7', name: '60 Minute Pregnancy Massage', price: 135, duration: 60,
          enhancementGroupIds: ['eg-main'],
          description: 'A gentle, nurturing massage for expectant mothers. Our certified prenatal therapist provides relief from the discomforts of pregnancy with specialized techniques and positioning.'
        },
        {
          id: 'svc-m8', name: '90 Minute Amber and Sage Massage', price: 160, duration: 90,
          enhancementGroupIds: ['eg-main', 'eg-cupping', 'eg-reiki'],
          description: 'Our signature massage extended to 90 minutes, allowing for a more thorough treatment and unhurried, focused attention across the whole body.'
        },
        {
          id: 'svc-m9', name: '90 Minute Medicinal Plant-Infused Lotion Massage', price: 195, duration: 90,
          enhancementGroupIds: ['eg-main', 'eg-cupping'],
          description: 'The extended version of our plant-infused massage. More time means deeper work and greater relief for significant tension or chronic conditions.'
        },
        {
          id: 'svc-m10', name: '90 Minute Hot Stone Massage', price: 198, duration: 90,
          enhancementGroupIds: ['eg-main'],
          description: 'Our most comprehensive hot stone experience. 90 minutes allows your therapist to work through every area of the body with deeply therapeutic warmth.'
        }
      ]
    },
    {
      id: 'cat-facials', name: 'Facials',
      services: [
        {
          id: 'svc-f1', name: '60 Minute Signature Facial', price: 105, duration: 60,
          enhancementGroupIds: ['eg-main'],
          description: 'Customized to your skin type and concerns. Includes cleansing, exfoliation, extractions, massage, masking, and targeted serums.'
        },
        {
          id: 'svc-f2', name: '90 Minute Deluxe Facial', price: 145, duration: 90,
          enhancementGroupIds: ['eg-main'],
          description: 'Our extended, deeply indulgent facial including everything in the signature facial plus face, neck, décolletage, and hand massage.'
        }
      ]
    },
    {
      id: 'cat-waxing', name: 'Waxing',
      services: [
        {
          id: 'svc-w1', name: 'Full Leg Wax', price: 85, duration: 45,
          enhancementGroupIds: [],
          description: 'Complete hair removal from ankle to thigh using premium hard wax for smooth, long-lasting results.'
        },
        {
          id: 'svc-w2', name: 'Brazilian Wax', price: 70, duration: 30,
          enhancementGroupIds: [],
          description: 'Complete intimate waxing performed with precision and care using the highest quality waxes.'
        }
      ]
    },
    {
      id: 'cat-lash', name: 'Lash and Brow (Lamination/Tinting)',
      services: [
        {
          id: 'svc-l1', name: 'Lash Lift & Tint', price: 95, duration: 60,
          enhancementGroupIds: [],
          description: 'Lifts and curls your natural lashes from the base, creating longer, fuller appearance. Tint deepens color for added definition. Lasts 6-8 weeks.'
        },
        {
          id: 'svc-l2', name: 'Brow Lamination', price: 75, duration: 45,
          enhancementGroupIds: [],
          description: 'Straightens and sets brow hairs for full, fluffy, defined brows. Results last 6-8 weeks.'
        }
      ]
    },
    {
      id: 'cat-bodycare', name: 'Body Care',
      services: [
        {
          id: 'svc-b1', name: 'Coconut Sugar Body Scrub', price: 95, duration: 60,
          enhancementGroupIds: ['eg-main'],
          description: 'A luxurious, all-natural exfoliating treatment using our coconut sugar blend. Leaves skin incredibly soft, smooth, and hydrated.'
        },
        {
          id: 'svc-b2', name: 'Body Wrap', price: 115, duration: 75,
          enhancementGroupIds: ['eg-main'],
          description: 'A nourishing full-body wrap combining detoxifying and moisturizing ingredients to deeply hydrate and revitalize skin.'
        }
      ]
    },
    {
      id: 'cat-soul', name: 'Soul',
      services: [
        {
          id: 'svc-s1', name: '60 Minute Reiki Session', price: 90, duration: 60,
          enhancementGroupIds: [],
          description: 'A gentle, non-invasive energy healing practice. Our certified practitioner channels universal life energy to restore balance and harmony to body, mind, and spirit.'
        }
      ]
    },
    {
      id: 'cat-yoga', name: 'Yoga',
      services: [
        {
          id: 'svc-y1', name: 'Private Yoga Session', price: 75, duration: 60,
          enhancementGroupIds: [],
          description: 'A one-on-one yoga session tailored to your needs and experience level. Guided by our certified instructor.'
        }
      ]
    }
  ],

  enhancementGroups: {
    'eg-main': {
      id: 'eg-main', name: 'Enhancements',
      selectionRule: 'multiple', maxSelections: null,
      addOns: [
        {
          id: 'ao-soul', name: 'Soul Unwind Blend', price: 20, durationAdd: 0,
          description: 'Soothes sore muscles with lavender, marjoram, eucalyptus, frankincense, and bergamot. Perfect for unwinding body and mind.'
        },
        {
          id: 'ao-tiger', name: 'Tiger Balm', price: 20, durationAdd: 0,
          description: 'Ancient camphor, menthol, and essential oil blend for deep tension, sore spots, and overworked bodies.'
        },
        {
          id: 'ao-slow', name: 'Slow Reintegration', price: 30, durationAdd: 15,
          description: 'An additional 15 minutes of uninterrupted time to slowly wake up and re-enter the conscious world after your treatment.'
        },
        {
          id: 'ao-plant', name: 'Medicinal Plant-Infused Lotion', price: 35, durationAdd: 0,
          description: 'High-quality hemp-derived products from Cause+Medic. Reduces inflammation, relieves pain, calms the nervous system.'
        },
        {
          id: 'ao-scrub', name: 'Body Scrub', price: 85, durationAdd: 40,
          description: 'Coconut Sugar Scrub Add-On — luxurious all-natural exfoliation that leaves skin incredibly soft, smooth, and hydrated.'
        },
        {
          id: 'ao-rlt', name: 'Red Light Therapy', price: 40, durationAdd: 0,
          description: 'Soothing red and infrared wavelengths during your massage to reduce inflammation and improve circulation.'
        },
        {
          id: 'ao-love', name: 'Love Oil', price: 20, durationAdd: 0,
          description: "Valentine's Day special: sandalwood, ylang ylang, rose, and vanilla blend. For a limited time only!"
        }
      ]
    },
    'eg-cupping': {
      id: 'eg-cupping', name: 'Cupping',
      selectionRule: 'single', maxSelections: 1,
      addOns: [
        {
          id: 'ao-cupping', name: 'Cupping', price: 20, durationAdd: 0,
          description: 'Traditional cupping therapy using suction to improve blood flow, reduce muscle tension, and promote healing.'
        }
      ]
    },
    'eg-reiki': {
      id: 'eg-reiki', name: 'Reiki',
      selectionRule: 'single', maxSelections: 1,
      addOns: [
        {
          id: 'ao-reiki-30', name: '30 Minutes Reiki', price: 60, durationAdd: 30,
          description: 'A 30-minute Reiki session added to your massage for energy alignment and deep restoration.'
        }
      ]
    }
  },

  providers: [
    {
      id: 'prov-f', type: 'filter-female', name: 'Female only', gender: 'female',
      workDays: {
        MON: [{ start: '9:00 am', end: '6:00 pm' }],
        TUE: [{ start: '9:00 am', end: '6:00 pm' }],
        WED: [{ start: '9:00 am', end: '6:00 pm' }],
        THU: [{ start: '9:00 am', end: '6:00 pm' }],
        FRI: [{ start: '9:00 am', end: '6:00 pm' }],
        SAT: [{ start: '9:00 am', end: '6:00 pm' }],
        SUN: [{ start: '9:00 am', end: '6:00 pm' }]
      },
      serviceIds: ['all'], enhancementIds: ['all'], price: 135
    },
    {
      id: 'prov-m', type: 'filter-male', name: 'Male only', gender: 'male',
      workDays: {
        MON: [{ start: '9:00 am', end: '5:00 pm' }],
        TUE: [{ start: '9:00 am', end: '5:00 pm' }],
        THU: [{ start: '9:00 am', end: '5:00 pm' }],
        FRI: [{ start: '9:00 am', end: '3:00 pm' }]
      },
      serviceIds: ['all'], enhancementIds: ['all'], price: 135
    },
    {
      id: 'prov-any', type: 'filter-any', name: 'Anyone', gender: 'any',
      workDays: {
        MON: [{ start: '9:00 am', end: '6:00 pm' }],
        TUE: [{ start: '9:00 am', end: '6:00 pm' }],
        WED: [{ start: '9:00 am', end: '6:00 pm' }],
        THU: [{ start: '9:00 am', end: '6:00 pm' }],
        FRI: [{ start: '9:00 am', end: '6:00 pm' }],
        SAT: [{ start: '9:00 am', end: '6:00 pm' }],
        SUN: [{ start: '9:00 am', end: '6:00 pm' }]
      },
      serviceIds: ['all'], enhancementIds: ['all'], price: 135
    },
    {
      id: 'prov-sarah', type: 'staff', initial: 'S', name: 'Sarah Clark', gender: 'female',
      workDays: {
        SAT: [{ start: '10:00 am', end: '4:00 pm' }],
        SUN: [{ start: '10:00 am', end: '3:00 pm' }]
      },
      serviceIds: ['all'],
      enhancementIds: ['ao-aromatherapy', 'ao-deep-tissue', 'ao-prenatal', 'ao-cbd-oil', 'ao-hot-stone', 'ao-scalp', 'ao-reiki-30'],
      price: 135, avatarBg: '#E5DDD6',
      timeOff: [{ startDate: '2026-03-07', endDate: '2026-03-09' }]
    },
    {
      id: 'prov-mariana', type: 'staff', initial: 'M', name: 'Mariana Osorio Mendoza', gender: 'female',
      workDays: {
        MON: [{ start: '9:15 am', end: '1:00 pm' }, { start: '2:00 pm', end: '5:30 pm' }],
        TUE: [{ start: '9:15 am', end: '1:00 pm' }, { start: '2:00 pm', end: '5:30 pm' }],
        WED: [{ start: '9:15 am', end: '1:00 pm' }, { start: '2:00 pm', end: '5:30 pm' }],
        THU: [{ start: '9:15 am', end: '1:00 pm' }, { start: '2:00 pm', end: '5:30 pm' }],
        SAT: [{ start: '10:00 am', end: '4:00 pm' }]
      },
      serviceIds: ['all'], enhancementIds: ['all'], price: 135, avatarBg: '#D4DED3'
    },
    {
      id: 'prov-mailen', type: 'staff', initial: 'M', name: 'Mailen Sastre', gender: 'female',
      workDays: {
        FRI: [{ start: '10:00 am', end: '6:00 pm' }],
        SUN: [{ start: '11:00 am', end: '5:00 pm' }]
      },
      serviceIds: ['all'],
      enhancementIds: ['ao-aromatherapy', 'ao-deep-tissue', 'ao-prenatal', 'ao-cbd-oil', 'ao-hot-stone', 'ao-scalp'],
      price: 135, avatarBg: '#E5DDD6'
    },
    {
      id: 'prov-heather', type: 'staff', initial: 'H', name: 'Heather Adams', gender: 'female',
      workDays: {
        MON: [{ start: '9:00 am', end: '2:00 pm' }],
        FRI: [{ start: '12:00 pm', end: '7:00 pm' }],
        SAT: [{ start: '9:00 am', end: '5:00 pm' }],
        SUN: [{ start: '10:00 am', end: '4:00 pm' }]
      },
      serviceIds: ['all'], enhancementIds: ['all'], price: 135, avatarBg: '#F2E4DC'
    },
    {
      id: 'prov-rob', type: 'staff', initial: 'R', name: 'Rob Christie', gender: 'male',
      workDays: {
        MON: [{ start: '9:00 am', end: '5:00 pm' }],
        TUE: [{ start: '9:00 am', end: '5:00 pm' }],
        THU: [{ start: '9:00 am', end: '5:00 pm' }],
        FRI: [{ start: '9:00 am', end: '3:00 pm' }]
      },
      serviceIds: ['all'],
      enhancementIds: ['ao-aromatherapy', 'ao-deep-tissue', 'ao-cbd-oil', 'ao-hot-stone', 'ao-scalp', 'ao-cupping'],
      price: 135, avatarBg: '#D4DED3'
    },
    {
      id: 'prov-kayla', type: 'staff', initial: 'K', name: 'Kayla Leach', gender: 'female',
      workDays: {
        TUE: [{ start: '10:00 am', end: '6:00 pm' }],
        WED: [{ start: '10:00 am', end: '6:00 pm' }],
        SAT: [{ start: '9:00 am', end: '5:00 pm' }],
        SUN: [{ start: '11:00 am', end: '4:00 pm' }]
      },
      serviceIds: ['all'],
      enhancementIds: ['ao-aromatherapy', 'ao-deep-tissue', 'ao-prenatal', 'ao-cbd-oil', 'ao-hot-stone', 'ao-scalp'],
      price: 135, avatarBg: '#E5DDD6'
    },
    {
      id: 'prov-jade', type: 'staff', initial: 'J', name: 'Jade Harry', gender: 'female',
      workDays: {
        FRI: [{ start: '10:00 am', end: '6:00 pm' }],
        SAT: [{ start: '9:00 am', end: '4:00 pm' }]
      },
      serviceIds: ['all'],
      enhancementIds: ['ao-aromatherapy', 'ao-deep-tissue', 'ao-prenatal', 'ao-cbd-oil', 'ao-hot-stone', 'ao-scalp', 'ao-reiki-30'],
      price: 135, avatarBg: '#F2E4DC'
    }
  ],

  formConfig: {
    fields: [
      { id: 'phone', type: 'tel', label: 'Enter your phone number', placeholder: '(000) 000-0000', required: true },
      {
        id: 'smsOpt', type: 'radio', label: 'Would you like to receive appointment reminders?', required: false,
        defaultValue: 'yes',
        options: [
          { value: 'yes', label: 'Yes, send appointment reminders', sublabel: 'By selecting Yes, you agree to receive appointment reminders and appointment-related texts from us — confirmations, deposit/payment links, and login verification codes. Message frequency varies. Msg & data rates may apply. Reply STOP to unsubscribe or HELP for help. We will not share your mobile information with third parties for promotional or marketing purposes. Privacy policy: getcalendoula.com/privacy' },
          { value: 'no', label: 'No, do not send appointment reminders', sublabel: 'You can opt out at any time. Data rates may apply. Reply STOP to cancel.' }
        ]
      },
      { id: 'firstName', type: 'text', label: 'First name', placeholder: 'Enter first name', required: true, half: true },
      { id: 'lastName', type: 'text', label: 'Last name', placeholder: 'Enter last name', required: true, half: true },
      { id: 'email', type: 'email', label: 'Email', placeholder: 'Enter email address', required: true },
      {
        id: 'forOther', type: 'toggle', label: 'I am booking for someone else',
        subPrompt: 'Please enter the name of the person you are booking for:',
        subFields: [
          { id: 'otherFirstName', type: 'text', label: 'First name', placeholder: 'Enter first name', required: true, half: true },
          { id: 'otherLastName', type: 'text', label: 'Last name', placeholder: 'Enter last name', required: true, half: true },
          { id: 'otherPhone', type: 'tel', label: 'Phone number', placeholder: '(000) 000-0000' },
          { id: 'otherEmail', type: 'email', label: 'Email address', placeholder: 'Enter email address' },
          {
            id: 'otherIsSurprise', type: 'toggle', label: 'This is a surprise',
            sublabel: "Notifications and reminders will be sent to you (the booker). It's your responsibility to communicate those to the recipient."
          }
        ]
      },
      { id: 'promo', type: 'text', label: 'Promo code', placeholder: 'e.g. SAVE20' },
      { id: 'comments', type: 'textarea', label: 'Comments (and/or if you have a gift card, enter the number here)', placeholder: 'Enter any comments or notes' }
    ],
    notices: [
      {
        id: 'checklist',
        html: '✅ <strong>Be sure to review the <a href="#" style="color:#B8623E">pre-appointment checklist</a>!</strong> Appointments unable to be completed due to any checklist condition will still be charged 100% of the service cost.'
      },
      {
        id: 'giftcards',
        html: '🎁🎁🎁 <strong>NATURAL BODY GIFT CARD HOLDERS:</strong><br>We cannot accept Natural Body gift cards if <a href="#" style="color:#B8623E">this questionnaire</a> has not been submitted at least one day prior to your appointment. <em>*Does not apply to Amber &amp; Sage gift cards.</em>'
      },
      {
        id: 'minor',
        html: 'If this appointment is for a minor, a parent/guardian release form must be filled out. <strong>Please let us know if this is for a minor.</strong> We cannot accept clients under 13.'
      }
    ]
  },

  availabilityConfig: {
    intervalMinutes: 10,
    sameDayMessage: 'Online booking is limited for same day appointments but openings may be available. Please text us at 423-537-4221 (preferred) or call us at 423-218-2841 with your request and we will do our best to accommodate you!'
  },

  giftCardConfig: {
    artworkUrl: null,
    minAmount: 25,
    maxAmount: 1000,
    disclaimer: `<p>Please note: promotional gift cards cannot be used in conjunction with other offers. This refers to gift card specials in which the value of the gift card is greater than the purchase price. We cannot do "discount stacking" unless explicitly stated as part of the deal. Thanks for your understanding and support!</p>
<p>Gift cards have no cash value and cannot be redeemed for cash or cash equivalents.</p>`,
    successMessage: `Your gift card has been sent! The recipient will receive an email shortly with their gift card and instructions for redemption. Thank you for your support — we can't wait to welcome them.`,
    viewCardBaseUrl: 'https://ambersagespa.com/gift-cards/'
  },

  gcPromotions: [
    { id: 1, name: 'Spring Special', description: 'Buy a $150 gift card for just $125 — a perfect treat for someone special.', cardValue: 150, salePrice: 125, artworkUrl: '', enabled: true },
    { id: 2, name: "Mother's Day", description: "Celebrate Mom with a $200 gift card for only $175.", cardValue: 200, salePrice: 175, artworkUrl: '', enabled: true },
  ],
  bookingLocations: [
    { id: 1, name: 'Amber and Sage', isPrimary: true },
    { id: 2, name: 'Aura', isPrimary: false },
  ],
};
